<template>
  <div
    :class="MARKDOWN_PROSE_CLASSES"
    v-html="sanitizedHtml"
  />
</template>

<script>
export const MARKDOWN_PROSE_CLASSES = 'max-w-none text-base leading-6 text-slate-700 dark:text-slate-300 [&_a]:font-medium [&_a]:text-indigo-600 [&_a]:underline dark:[&_a]:text-indigo-400 [&_blockquote]:my-2.5 [&_blockquote]:border-l-4 [&_blockquote]:border-slate-200 [&_blockquote]:pl-4 [&_blockquote]:text-slate-600 dark:[&_blockquote]:border-slate-700 dark:[&_blockquote]:text-slate-400 [&_code]:bg-slate-100 [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-slate-900 dark:[&_code]:bg-slate-800 dark:[&_code]:text-slate-100 [&_h1]:mb-2 [&_h1]:text-2xl [&_h1]:font-semibold [&_h1]:text-slate-950 dark:[&_h1]:text-slate-100 [&_h2]:mb-1.5 [&_h2]:mt-4 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-slate-950 dark:[&_h2]:text-slate-100 [&_h3]:mb-1.5 [&_h3]:mt-3 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-slate-900 dark:[&_h3]:text-slate-100 [&_li]:my-0.5 [&_li_p]:mb-0 [&_ol]:mb-2.5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:mb-2.5 [&_pre]:mb-2.5 [&_pre]:overflow-auto [&_pre]:border [&_pre]:border-slate-200 [&_pre]:bg-slate-100 [&_pre]:p-3 dark:[&_pre]:border-slate-700 dark:[&_pre]:bg-slate-800 [&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_strong]:font-semibold [&_strong]:text-slate-900 dark:[&_strong]:text-slate-100 [&_ul]:mb-2.5 [&_ul]:list-disc [&_ul]:pl-5'
</script>

<script setup>
import { computed } from 'vue'
import DOMPurify from 'dompurify'
import { marked } from 'marked'

const props = defineProps({
  source: {
    type: String,
    default: '',
  },
})

const ALLOWED_URI_REGEXP = /^(?:(?:https?|mailto):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i

function renderMarkdown(raw) {
  const html = marked.parse(raw || '', { async: false })
  return DOMPurify.sanitize(html, { ALLOWED_URI_REGEXP })
}

const sanitizedHtml = computed(() => renderMarkdown(props.source))
</script>
